var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Email",
    transform: "translate(23 -21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    transform: "translate(-23 21)",
    fill: "none",
    stroke: "#00b26b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_material-attach-email",
    "data-name": "Icon material-attach-email",
    transform: "translate(-15.45 29.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M18.5,9.8V4.7A1.7,1.7,0,0,0,16.8,3H3.2A1.7,1.7,0,0,0,1.509,4.7L1.5,14.9a1.7,1.7,0,0,0,1.7,1.7h9.35V12.35A2.547,2.547,0,0,1,15.1,9.8Zm-8.5.85L3.2,6.4V4.7L10,8.95,16.8,4.7V6.4Z",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M27.6,19.05v3.4a1.7,1.7,0,0,1-3.4,0V18.625a.425.425,0,0,1,.85,0V22.45h1.7V18.625a2.125,2.125,0,0,0-4.25,0V22.45a3.4,3.4,0,0,0,6.8,0v-3.4Z",
    transform: "translate(-9.1 -5.85)",
    fill: "#00b26b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.66b5ac8c4ee31d4036ddd4b36a044fc3.svg";
export { ForwardRef as ReactComponent };